import store from "../store";

export const subawardListSelectors = {
	isFetching: (state = store.getState()) => state.subawards.isFetching,
	isRefresh: (state = store.getState()) => state.subawards.isRefresh,
	summary: (state = store.getState()) => state.subawards.summary,
	search: (state = store.getState()) => state.subawards.content.search,
	content: (state = store.getState()) => state.subawards.content,
};
